import wordmark from './assets/vendoiq-wordmark.png';

/**
 * Shared VendoIQ wordmark — one asset, identical in both admin SPA shells
 * (ADR 016). Each shell places it in the AdminLayout `brand` slot.
 */
export function Wordmark({ height = 32 }: { height?: number }) {
  return (
    <img
      src={wordmark}
      alt="VendoIQ"
      style={{ height, objectFit: 'contain' }}
    />
  );
}
